import React, { Fragment } from 'react';

export default {
  units: [
    {
      id: 'B8',
      mockup: (
        <g id="b8" transform="translate(258.000000, 156.833984)">
          <polygon
            id="fill-b8"
            stroke="#0B1A27"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="86.9725642 16.4292609 86.9725642 0.115736238 0.873406422 0.115736238 0.873406422 16.4292609 0.873406422 51.0597255 0.873406422 71.0938785 0.873406422 72.8110916 31.44934 72.8110916 31.44934 71.0938785 94.7000233 71.0938785 94.7000233 51.0597255 123.320242 51.0597255 123.320242 16.4292609"
          />
          <text
            id="02"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="41.604" y="32.4634139">
              02
            </tspan>
          </text>
          <text
            id="B8"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="40.824" y="47.3459276">
              B8
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C1a',
      mockup: (
        <g id="c1a" transform="translate(202.000000, 156.833984)">
          <polygon
            id="fill-c1a"
            stroke="#000000"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="87.44934 91.4142338 77.1460613 91.4142338 77.1460613 72.8110916 56.9287109 72.8110916 56.9287109 0.145019531 19.2504883 0.145019531 0.823730469 128.79834 14.0898438 128.79834 14.0898438 154.993652 109.342773 154.993652 109.342773 91.4142338"
          />
          <text
            id="01"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="37.1749246" y="103.223432">
              01
            </tspan>
          </text>
          <text
            id="C1a"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="33.4249246" y="119.223432">
              C1a
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C3',
      mockup: (
        <g id="c3" transform="translate(369.000000, 164.833984)">
          <polygon
            id="fill-c3"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.585952278 63.0938785 0.585952278 43.3459276 12.3202419 43.3459276 12.3202419 8.42926087 9.74442225 8.42926087 9.74442225 0.848632812 83.5917969 0.848632813 99.3706055 151.879883 23.8686523 151.879883 23.8686523 63.0938785"
          />
          <text
            id="03"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="50.0822789" y="79.2234323">
              03
            </tspan>
          </text>
          <text
            id="C3"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="49.5122789" y="94.8991983">
              C3
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'A3',
      mockup: (
        <g id="a3" transform="translate(392.000000, 316.833984)">
          <polygon
            id="fill-a3"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="73.7021866 66.0246622 31.6781655 66.0246622 31.6781655 54.5765747 3.05794689 54.5765747 3.05794689 48.1847259 3.05794689 30.5644531 0.858886719 30.5644531 0.858886719 0.166015625 76.3979492 0.166015625 80.2001953 35.1694336"
          />
          <text
            id="04"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="37.3503578" y="25.4401903">
              04
            </tspan>
          </text>
          <text
            id="A3"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="36.7983578" y="41.4401903">
              A3
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C4',
      mockup: (
        <g id="c4" transform="translate(337.000000, 364.833984)">
          <polygon
            id="fill-c4"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.817509564 9.5 0.817509564 90.8154183 112.902344 90.8154183 128.792969 17.8583984 86.7211914 17.8583984 86.7211914 6.64306641 58.2670898 6.64306641 58.2670898 0.160644531 12.6098633 0.160644531 12.6098633 9.5"
          />
          <text
            id="05"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="42.9628867" y="44.5457588">
              05
            </tspan>
          </text>
          <text
            id="C4"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="42.3928867" y="60.5457588">
              C4
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C5',
      mockup: (
        <g id="c5" transform="translate(218.000000, 364.833984)">
          <polygon
            id="fill-c5"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="0.184995558 61.4319938 0.184995558 57.9975676 45.404941 57.9975676 45.404941 5.33636527 85.187045 5.33636527 85.187045 0.184725908 103.279297 0.184725908 103.279297 9.83886719 119.666016 9.83886719 119.666016 110.445801 121.569824 110.445801 121.569824 117.315918 0.184995558 117.315918 0.184995558 110.445801 1.79199219 110.445801 1.79199219 93.3486328 0.184995558 93.3486328 0.184995558 81.9033203 1.79199219 81.9033203 1.79199219 70.4702148 0.184995558 70.4702148"
          />
          <text
            id="06"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="68.104" y="57.4880314">
              06
            </tspan>
          </text>
          <text
            id="C5"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="67.534" y="73.4880314">
              C5
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: 'C6',
      mockup: (
        <g id="c6" transform="translate(195.000000, 308.833984)">
          <polygon
            id="fill-c6"
            stroke="#0B1A27"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="20.9907788 0.661501704 20.9907788 2.9511192 116.391508 2.9511192 116.391508 38.3041992 108.14209 38.3041992 108.14209 61.6601563 68.6911432 61.6601563 68.6911432 114.310547 23.324707 114.310547 23.324707 117.342773 0.0229492188 117.342773 0.0229492188 75.1279297 17.6787109 75.1279297 17.6787109 47.4238281 7.00390625 47.4238281 7.00390625 49.1767578 0.0229492188 49.1767578 0.0229492188 0.661501704"
          />
          <text
            id="07"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="40.1749246" y="34.4401903">
              07
            </tspan>
          </text>
          <text
            id="C6"
            fontFamily="DINOT-Medium, DIN OT"
            fontSize="12"
            fontWeight="400"
            fill="#F58220"
          >
            <tspan x="39.6049246" y="50.4401903">
              C6
            </tspan>
          </text>
        </g>
      ),
    },
  ],
  outline: (
    <Fragment>
      <text
        id="LEVEL-15-–-18"
        fontFamily="DINCanfor-Medium, DIN Canfor"
        fontSize="16"
        fontWeight="400"
        fill="#0B1A27"
      >
        <tspan x="283.076" y="597.839844">
          LEVEL 15 – 18{' '}
        </tspan>
      </text>
      <g
        id="bg-lines"
        transform="translate(180.000000, 143.833984)"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.38"
      >
        <polyline
          id="Shape"
          points="163.255351 104.414234 131.486908 104.414234 131.486908 203.44019 163.255351 203.44019"
        />
        <polyline
          id="Shape"
          points="15.0026184 242.363688 0.406306924 242.363688 0.406306924 212.026256 15.0026184 212.026256"
        />
        <rect
          id="Rectangle-path"
          x="163.255351"
          y="104.414234"
          width="26.044399"
          height="99.0259566"
        />
        <path
          d="M163.255351,136.468879 L189.29975,136.468879 M163.255351,170.240737 L189.29975,170.240737"
          id="Shape"
        />
        <path
          d="M147.800433,181.402622 L147.800433,128.169015 M131.773111,181.402622 L163.255351,181.402622 M131.773111,128.169015 L163.255351,128.169015"
          id="Shape"
        />
        <path
          d="M189.29975,203.44019 L163.255351,170.049935 L189.29975,136.278077 L163.255351,104.223432 M163.255351,203.249389 L189.29975,169.859134 L163.255351,136.468879 L189.29975,104.414234"
          id="Shape"
        />
        <path
          d="M288.325707,172.816556 L212.768329,172.816556 L288.325707,172.816556 Z"
          id="Path"
        />
        <polygon
          id="Path"
          points="141.217783 221.184726 141.217783 230.724799 169.551799 230.724799 169.551799 221.184726"
        />
        <polyline
          id="Path"
          points="189.776754 64.3459276 172.986225 64.3459276 172.986225 84.0938785"
        />
        <polygon
          id="Path"
          points="165.354167 13.1157362 165.354167 29.4292609 198.744422 29.4292609 198.744422 21.7018018 272.584586 21.7018018 292.046335 208.019425 270.008767 311.910819 157.81751 311.910819 157.81751 331.372568 159.534723 331.372568 159.534723 338.24142 38.1849956 338.24142 38.1849956 331.372568 39.9022087 331.372568 39.9022087 314.200437 38.1849956 314.200437 38.1849956 302.752349 39.9022087 302.752349 39.9022087 291.495063 38.1849956 291.495063 38.1849956 282.431994 15.0026184 282.431994 15.0026184 240.07407 32.8902551 240.07407 32.8902551 212.59866 21.8714709 212.59866 21.8714709 214.029671 15.0026184 214.029671 15.0026184 165.661502 36.1815803 165.661502 36.1815803 141.811319 23.0162797 141.811319 41.0470174 13.1157362"
        />
        <polyline
          id="Path"
          points="109.44934 85.8110916 78.8257061 85.8110916 78.8257061 13.1157362"
        />
        <polygon
          id="Path"
          points="131.296107 203.44019 123.187045 203.44019 123.187045 221.184726 215.057947 221.184726 215.057947 203.44019 212.768329 203.44019 212.768329 84.1892792 109.44934 84.1892792 109.44934 104.509634 131.486908 104.509634"
        />
        <polyline
          id="Path"
          points="159.534723 338.24142 200.461635 338.24142 200.461635 311.910819"
        />
        <polyline
          id="Path"
          points="284.605078 147.759766 306.928849 147.759766 306.928849 243.794699 284.605078 243.794699"
        />
        <polyline
          id="Path"
          points="15.0026184 165.661502 15.0026184 138.186092 23.588684 138.186092"
        />
        <polygon
          id="Shape"
          points="21.5852687 338.24142 15.0026184 338.24142 15.0026184 331.372568 18.1508425 331.372568 18.1508425 334.806994 21.5852687 334.806994"
        />
        <polyline
          id="Shape"
          points="198.744422 21.7018018 198.744422 0.51171875 163.894531 0.51171875 163.894531 14.7111489"
        />
        <path d="M288.325707,172.816556 L306.928849,172.816556" id="Shape" />
        <path d="M15.0026184,331.372568 L15.0026184,282.431994" id="Shape" />
        <path d="M21.5852687,338.24142 L38.1849956,338.24142" id="Shape" />
      </g>
      <g
        id="compass"
        transform="translate(563.051950, 473.966278)"
        fill="#0B1A27"
        fillRule="nonzero"
      >
        <polygon
          id="Shape"
          points="10.332078 38.8487477 3.78150781 29.9369255 3.78150781 38.8487477 0.848985112 38.8487477 0.848985112 25.1382519 3.85767723 25.1382519 10.2178239 33.7834812 10.2178239 25.1382519 13.1503466 25.1382519 13.1503466 38.8487477"
        />
        <polygon
          id="Shape"
          points="11.8935511 13.0653988 7.01870819 4.26783067 2.10578055 13.0653988 0.468138008 12.113281 7.01870819 0.345105502 13.5311937 12.113281"
        />
        <rect
          id="Rectangle-path"
          x="6.06659043"
          y="2.32551044"
          width="1.90423552"
          height="21.1370143"
        />
      </g>
    </Fragment>
  ),
};



// WEBPACK FOOTER //
// ./src/data/floorplates/svg/level15-18.js